<template>
	<div class="wenhaoIconWrap">
		<img class="wenhaoIcon" src="../../../assets/icon_dean_home_alert_icon_17.png" alt="">
		<div class="whBubble">
			<img class="home_pic_triangle_d" src="../../../assets/home_pic_triangle_d.png" alt="">
			<div class="tooltiptext" style="">
				<div class="ahi-title">
					·体动指数是您睡眠阶段平均每小时体动次数的指标，体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，如无其他不适，均视为正常。
				</div>
			</div>
		</div>
	</div>
</template>
  
<script>

export default {
	components: {
	},
	props: {
		data: null,
	},
	watch: {
		
	},
	data() {
		return {
		};
	},
	created() { },
	mounted() {
		
	},
	methods: {
	},
};
</script>
<style lang="scss" scoped>

.bot_advice_tit {
	box-sizing: border-box;
	padding-left: 14px;

	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #5E6779;
	line-height: 24px;
	position: relative;

	.bot_adv_tag {
		padding: 1px 10px 1px 5px;
		background: #FFE0E4;
		border-radius: 19px;
		border: 1px solid #FFB8C3;
		backdrop-filter: blur(8px);
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #5E6779;

		display: inline-block;

		.tanhaoIcon {
			width: 14px;
			height: 14px;
			// margin-right: 3px;
			margin-top: -3px;
		}
	}
}

.bot_advice_tit::after {
	width: 4px;
	height: 4px;
	background: #80C0FD;
	border-radius: 2px;
	content: '';

	position: absolute;
	left: 0px;
	top: 11px;
}


.wenhaoIconWrap:hover .whBubble {
	display: block;
}

.wenhaoIconWrap {
	width: 20px;
	height: 20px;
	margin-left: 5px;
	margin-top: 0px;
	cursor: pointer;
	position: relative;

	.wenhaoIcon {
		width: 100%;
		height: 100%;
		display: block;
	}

	.whBubble {
		width: 320px;
		// height: 128px;
		background: #FFFFFF;
		box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
		border-radius: 8px;
		padding: 20px;
		box-sizing: border-box;

		position: absolute;
		top: -200px;
		left: -150px;
		z-index: 999;
		display: none;

		.home_pic_triangle_d {
			width: 38px;
			height: 16px;
			display: block;
			position: absolute;
			left: 50%;
			bottom: -16px;
			transform: translateX(-50%);
		}

		.bubbleTit {
			width: 335px;
			font-size: 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #5E6779;
			line-height: 24px;
			position: relative;
		}

		.bubbleTit::after {}

		.bubbleTipWrap {
			margin-top: 2px;
			display: flex;
			align-items: center;

			.bubbleTip_upImg {
				width: 9px;
				height: 12px;
				display: block;
			}

			.bubbleTip {
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #5E6779;
			}
		}
	}

}

.ahi-title {
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #1f2635;
}

.ahi-title::before {
	content: "";
	display: inline-block;
	width: 3px;
	height: 18px;
	background: #4d8ef7;
	border-radius: 2px;
	position: absolute;
	top: 21px;
	left: 0;
}

.ahi-item {
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #5e6779;
	margin: 10px 0;
}

.ahi-item::before {
	content: "";
	display: inline-block;
	width: 8px;
	height: 8px;
	background: #4d8ef7;
	border-radius: 50%;
	margin-right: 8px;
}

.ahi-item2::before {
	background: #ffc471;
}

.ahi-item3::before {
	background: #ff7186;
}
</style>
  